/**
 * Overview calendar “Preview” deep link (?tab=overview&preview=&previewId=).
 * kind: "class" | "pt" | "facility"
 */
export function buildSchedulingCalendarPreviewUrl(kind, id) {
  const k =
    kind === "class"
      ? "class"
      : kind === "pt"
        ? "pt"
        : kind === "facility"
          ? "facility"
          : "class";
  return `/coaching-portal/scheduling?tab=overview&preview=${k}&previewId=${encodeURIComponent(String(id))}`;
}
